import React from 'react';
import { FiX } from 'react-icons/fi';
//link
// import { Link } from 'react-router-dom';

const CategoryNavMobile = ({setcatNavMobile}) => {

return(
     <div className='w-full h-full bg-white p-8 '>
      <div onClick={()=>setcatNavMobile(false)}
       className='flex justify-end mb-8 cursor-pointer'>
        <FiX className='text-3xl'/> 
      </div>
      <div className='flex flex-col gap-y-8 cursor-pointer'>
        <p to='' className=' hover:text-body hover:underline text-gray-500 text-[25px] transition-all cursor-pointer'>Home</p>
        <p to='' className=' hover:text-body hover:underline text-gray-500 text-[25px] transition-all cursor-pointer'>Catalog</p>
        <p to='' className=' hover:text-body hover:underline text-gray-500 text-[25px] transition-all cursor-pointer'>Contact</p>
      </div>
      </div>
  )
    };

export default CategoryNavMobile;
